/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

import logo from '../../assets/logo_gndi_menu.png';

import Button from '../Button';
import Icon from '../Icons';
import Modal from '../Modal';

import { useGlobal } from '../../contexts/Global/context';

import { checkAllowedRoute, pathsAllowedToSpecificContract, checkIsSupport } from '../../utils';

import menuStructure from './menuStructure';

import * as S from './styles';

const MenuContent = ({ handleDrawerToggle }) => {
    const dataGlobal = useGlobal();

    const { dataLogin, dataActiveContract, contractsList } = dataGlobal;

    const [activeMenu, setActiveMenu] = useState('Home');
    const [activeSubItem, setActiveSubItem] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [checkSup, setCheckSup] = useState(true);

    const { contrastTheme } = useGlobal();

    function handleItemSelect(itemTitle, subItem, haveSubItem) {
        if (itemTitle === activeMenu) return;

        if (!haveSubItem) handleDrawerToggle();

        if (!subItem) {
            if (activeMenu === itemTitle) itemTitle = '';

            setActiveMenu(itemTitle);

            if (!haveSubItem) setActiveSubItem(itemTitle);
        } else {
            setActiveSubItem(itemTitle);
        }
    }

    function handleModalOpen() {
        setModalIsOpen(!modalIsOpen);
    }

    function handleCheckSupport() {
        if (checkIsSupport()) {
            setCheckSup(false);
        }
    }

    useEffect(() => {
        handleCheckSupport();
    }, [checkIsSupport()]);

    function MenuItem({ link, title, subItem, icon, disabled }) {
        const iconColor = disabled ? '#CCCCCC' : contrastTheme ? '#FFF333' : '#F49E00';

        return (
            <li>
                {disabled ? (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a className="menu-item disabled-item">
                        {icon && <Icon name={icon} style={{ color: iconColor, marginRight: '6px' }} />}
                        <S.MenuItemTitle>{title}</S.MenuItemTitle>
                    </a>
                ) : (
                    <LinkRouter
                        to={link}
                        className={`
                            menu-item 
                            ${subItem && 'sub-item'} 
                            ${(activeMenu === title || activeSubItem === title) && 'active'}
                        `}
                        onClick={() => handleItemSelect(title, subItem)}
                        id={title}
                    >
                        {icon && <Icon name={icon} style={{ color: iconColor, marginRight: '6px' }} />}
                        <S.MenuItemTitle>{title}</S.MenuItemTitle>
                    </LinkRouter>
                )}
            </li>
        );
    }

    return (
        <>
            <S.Logo>
                <img src={logo} height="40" alt="logo" />
            </S.Logo>

            <S.MenuList>
                {menuStructure.map((menu, parentIndex) => {
                    if (dataActiveContract.isSpecificContract && !pathsAllowedToSpecificContract.includes(menu.link)) {
                        return <React.Fragment key={`not-found-${parentIndex}`} />;
                    }

                    const checkAllowedParameter = {
                        path: menu.link,
                        dataGlobal,
                    };

                    const isAdmin =
                        dataLogin.loggedFlow === 'B2C_1_Suporte_flow' ||
                        dataLogin?.permissoes.find(({ id }) => +id === 8);

                    const allowedMenu = checkAllowedRoute(checkAllowedParameter);

                    if (!allowedMenu) {
                        return <MenuItem key={menu.title} {...menu} allowedMenu={allowedMenu} link="/" disabled />;
                    }

                    const Iconcolor = !allowedMenu ? '#CCCCCC' : contrastTheme ? '#FFF333' : '#F49E00';

                    const hasChildrens = !!menu.childrens && menu.childrens.length > 0;

                    if (hasChildrens) {
                        const someChildrenActive =
                            menu.childrens.find((children) => children.title === activeMenu) || {};

                        const menuIsActive = activeMenu === menu.title || !!someChildrenActive.title;

                        return (
                            <li key={parentIndex}>
                                <div
                                    className={`menu-item ${menuIsActive ? 'active' : ''}`}
                                    onClick={() => handleItemSelect(menu.title, false, true)}
                                >
                                    <Icon name={menu.icon} style={{ color: Iconcolor, marginRight: '6px' }} />
                                    <S.MenuItemTitle>{menu.title}</S.MenuItemTitle>
                                </div>

                                <S.MenuList className={`sub-menu ${menuIsActive ? 'open' : 'closed'}`}>
                                    {menu.childrens.map((children, childrenIndex) => {
                                        if (
                                            dataActiveContract.isSpecificContract &&
                                            !pathsAllowedToSpecificContract.includes(children.link)
                                        ) {
                                            return <React.Fragment key={`not-found-${childrenIndex}`} />;
                                        }

                                        if (children.title === 'Alterar senha') {
                                            return checkSup ? (
                                                <button
                                                    key={`${children.title}-${childrenIndex}`}
                                                    type="button"
                                                    className="menu-item sub-item"
                                                    style={{ border: 0, background: 'transparent' }}
                                                    onClick={handleModalOpen}
                                                >
                                                    <S.MenuItemTitle>{children.title}</S.MenuItemTitle>
                                                </button>
                                            ) : (
                                                ''
                                            );
                                        }

                                        if (
                                            children.link?.includes('selecionar_lotacao') &&
                                            (dataActiveContract.isPme || dataActiveContract.isAdesao)
                                        ) {
                                            return <React.Fragment key={`not-found-${childrenIndex}`} />;
                                        }

                                        if (children.link?.includes('gerenciar_usuarios') && !isAdmin) {
                                            return <React.Fragment key={`not-found-${childrenIndex}`} />;
                                        }

                                        if (
                                            children.link?.includes('reativar_beneficiario') &&
                                            !dataActiveContract.isAdesao
                                        ) {
                                            return <React.Fragment key={`not-found-${childrenIndex}`} />;
                                        }

                                        if (
                                            children.link.includes('centro_custo') &&
                                            !(dataActiveContract.isPj || dataActiveContract.isDental)
                                        ) {
                                            return <React.Fragment key={`not-found-${childrenIndex}`} />;
                                        }

                                        if (children.title === 'Serviços do beneficiário') {
                                            return (
                                                <a
                                                    key={`${children.title}-${childrenIndex}`}
                                                    href={children.externalLink}
                                                    target="blank"
                                                    className="menu-item sub-item"
                                                >
                                                    <S.MenuItemTitle>{children.title}</S.MenuItemTitle>
                                                </a>
                                            );
                                        }

                                        if (children.billingRedirectURLKey) {
                                            const redirectPath =
                                                dataActiveContract.billingRedirectUrls[children.billingRedirectURLKey];

                                            return (
                                                <a
                                                    key={`${children.title}-${childrenIndex}`}
                                                    href={`${children.redirectDomain}${redirectPath}`}
                                                    target="_blank"
                                                    className="menu-item sub-item"
                                                    rel="noreferrer"
                                                >
                                                    <S.MenuItemTitle>{children.title}</S.MenuItemTitle>
                                                </a>
                                            );
                                        }

                                        if (children.title === 'Registro de acidentados') {
                                            if (!dataActiveContract.isSpecificContract) {
                                                return <React.Fragment key={`not-found-${childrenIndex}`} />;
                                            }

                                            return (
                                                <a
                                                    key={`${children.title}-${childrenIndex}`}
                                                    href={children.externalLink}
                                                    target="blank"
                                                    className="menu-item sub-item"
                                                >
                                                    <S.MenuItemTitle>{children.title}</S.MenuItemTitle>
                                                </a>
                                            );
                                        }

                                        // transferencia_beneficiario
                                        if (
                                            children.link.includes('transferencia_beneficiario') &&
                                            contractsList.length <= 1
                                        ) {
                                            return <React.Fragment key={`${children.title}-${childrenIndex}`} />;
                                        }

                                        if (
                                            children.link.includes('aposentados_demitidos') &&
                                            !dataActiveContract.exigeTermoContributario
                                        ) {
                                            return <React.Fragment key={`${children.title}-${childrenIndex}`} />;
                                        }

                                        return (
                                            <MenuItem
                                                key={`${children.title}-${childrenIndex}`}
                                                subItem
                                                {...children}
                                                link={menu.link + children.link}
                                            />
                                        );
                                    })}
                                </S.MenuList>
                            </li>
                        );
                    }

                    return <MenuItem key={menu.title} {...menu} />;
                })}

                {dataActiveContract.isGPA && (
                    <a
                        className="menu-item"
                        href="http://integro.intermedica.com.br/servicosPortal/loginAcessoEmpresa.jsp"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Icon name="open_in_new" color={contrastTheme ? '#FFFFFF' : '#F49E00'} />
                        <S.MenuItemTitle>Registro de Acidentados</S.MenuItemTitle>
                    </a>
                )}
            </S.MenuList>

            <Modal
                title="Atenção"
                subtitle="Você será redirecionado para um ambiente seguro para efetuar a alteração da senha."
                visible={modalIsOpen}
                onCancel={handleModalOpen}
                footer={null}
            >
                <Button type="primary" onClick={handleModalOpen} style={{ padding: 0 }}>
                    <S.StyledLink
                        href={process.env.REACT_APP_CHANGE_PASSWORD_URL}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        Entendi
                    </S.StyledLink>
                </Button>
            </Modal>
        </>
    );
};

const Menu = ({ mobileOpen, handleDrawerToggle }) => {
    const { contrastTheme } = useGlobal();

    const useStyles = makeStyles(() => ({
        drawerPaper: {
            width: 248,
            backgroundColor: `${contrastTheme ? '#000000' : '#3C393C'}`,
            borderRight: `1px solid ${contrastTheme ? '#FFFFFF' : 'transparent'}`,
            color: `${contrastTheme ? '#FFF333' : '#FFFFFF'}`,
            zIndex: 100,
        },
    }));

    const classes = useStyles();

    return (
        <>
            <div className="hide-desktop">
                <SwipeableDrawer
                    container={window?.document?.body}
                    variant="temporary"
                    anchor="left"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    onOpen={handleDrawerToggle}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true,
                    }}
                >
                    <MenuContent handleDrawerToggle={handleDrawerToggle} />
                </SwipeableDrawer>
            </div>
            <div className="hide-mobile">
                <Drawer
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    variant="permanent"
                    open
                >
                    <MenuContent handleDrawerToggle={handleDrawerToggle} />
                </Drawer>
            </div>
        </>
    );
};

export default Menu;
